"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SURVEY_FOOTNOTE_MARKER = void 0;
/**
 * Reference mark tying a survey question to its footnote.
 *
 * Deliberately not stored in the question copy, so a translator cannot drop or
 * normalise it. Callers are expected to render it only when the question has a
 * footnote -- nothing here enforces that, and the `showFootnoteMarker` props on
 * QuestionField and QuestionHeader take a bare boolean.
 *
 * Web wraps it in `<sup>`; mobile interpolates it as a bare string, since React
 * Native has no superscript. Note the glyph already sits high in the em box, so
 * it reads as raised on mobile without an offset -- do not add one. Web is
 * marked `aria-hidden`, as the mark is decorative and reads as "asterisk
 * asterisk" otherwise; mobile hides it the same way, via an explicit
 * `accessibilityLabel` on the title and footnote in StepsScreen.
 */
exports.SURVEY_FOOTNOTE_MARKER = '**';
